module.exports = __webpack_public_path__ + "static/media/success-sound-effect.0c2d3ba5.mp3";